import Api from 'App/api'

export const getRentedItems = Api.get({
  controller: 'rentable_items',
  action: 'listMyItems',
})

export const getRentableItems = Api.get({
  controller: 'rentable_items',
  action: 'listWithSettings',
})

export const saveRentableItems = Api.post({
  controller: 'rentable_items',
  action: 'save',
})
